import useGlobalState from '@/composable/states/useGlobalState';
import { Hope } from '@/domain/hope.entity';

const { mutate, state } = useGlobalState<Hope[]>({ default: [] as Hope[] });

export default function useHopeState() {
  return {
    hopes: state,
    setHopes: mutate,
  };
}
